import React, { Component } from "react";
import {
	Button,
	Typography,
	GridList,
	GridListTile,
	IconButton,
} from "@material-ui/core";
import FileUploadIcon from "@material-ui/icons/CameraAltRounded";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoIcon from "@material-ui/icons/Info";
import { Field } from "redux-form";
import FileInput from "./FileInput";
import ContentSelectAll from "@material-ui/icons/SelectAll";

const styles = {
	gridList: {
		display: "flex",
		flexWrap: "nowrap",
		overflowX: "auto",
		width: "auto"
	},
	input: {
		cursor: "pointer",
		position: "absolute",
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		width: "100%",
		opacity: 0
	}
};

class ImageSelector extends Component {
	constructor(props) {
		super(props);
		// console.log("IMAGE ", props.imagePreviewUrl)
		this.state = {
			imagePreviewUrl: this.props.imagePreviewUrl,
			sizeErrorText: null,
			fileName: this.props.fileName,
		};
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.imagePreviewUrl !== this.props.imagePreviewUrl) {
			// console.log("CHANGE IMAGE ", nextProps.imagePreviewUrl)
			this.setState({
				imagePreviewUrl: nextProps.imagePreviewUrl,
				fileName: nextProps.fileName
			});
		}
	}

	handleImageChange(e) {
		e.preventDefault();
		let reader = new FileReader();
		reader.onloadend = () =>
			this.setState({ imagePreviewUrl: reader.result, sizeErrorText: null });
		reader.readAsDataURL(e.target.files[0]);

		if (e.type !== "blur")
			this.refs.field.getRenderedComponent().refs.FileInput.blur();
	}

	adaptFileEventToValue = delegate => e => {
		if (e.target.files[0]) {
			// e.preventDefault();
			// let reader = new FileReader()
			// let img = new Image()
			// let dimensions = {}

			// reader.onloadend = () => {
			// 	img.onload = () => {
			// 		dimensions.width = img.width
			// 		dimensions.height = img.height
			// 		console.log(img.width, img.height)
			// 		console.log(this.props.fileDimentions.width)
			// 		console.log(this.props.fileDimentions.height)
			// 	}
			// 	img.src = reader.result
			// }
			// reader.readAsDataURL(e.target.files[0])

			if (e.target.files[0].size <= this.props.fileSize) {
				// if (e.target.files[0].size <= this.props.fileSize &&
				//img.width === this.props.fileDimentions.width &&
				//img.height === this.props.fileDimentions.height) {
				this.handleImageChange(e);
				//añadido para sindicato controlador de estado de la pantalla a la que pertenece
				// eslint-disable-next-line
				this.props.onChangeState ? this.props.onChangeState() : null;
				delegate(e.target.files[0]);
				this.setState({ fileName: e.target.files[0].name });
			} else
				this.setState({
					sizeErrorText: `La imagen debe ser de 
			${this.props.fileDimentions.width}x
			${this.props.fileDimentions.height} y el tamaño no debe superar ${this.props
							.fileSize / 1000}kb`,
					fileName: null
				});
		}
	};

	deleteFile = () => {
		const fieldName = this.props.fieldName;
		const dispatch = this.refs.field.context._reduxForm.dispatch;
		const change = this.refs.field.context._reduxForm.change;
		dispatch(change(fieldName, ""));
		this.refs.field.getRenderedComponent().refs.FileInput.value = "";
		this.setState({ imagePreviewUrl: null, fileName:null });
		// eslint-disable-next-line
		this.props.onChangeDeleteFlag ? this.props.onChangeDeleteFlag() : null;
	};

	renderPreviews() {
		let previewUrl = this.state.imagePreviewUrl;
		if (previewUrl)
			return (
				<div style={this.props.styleRenderPreviews}>
					<Typography variant="subtitle1">Vista previa</Typography>
					<GridList cols={2} style={styles.gridList} cellHeight="auto">
						<GridListTile
							title=" "
							style={{ width: 300, height: 180 }}
							actionIcon={
								this.props.disabledUploadPhoto ? null : (
									<IconButton onClick={this.deleteFile}>
										<DeleteIcon color="white" />
									</IconButton>
								)
							}
						>
							<img
								style={{ height: "100%", width: "100%", objectFit: "contain" }}
								src={previewUrl}
								alt=""
							/>
						</GridListTile>
					</GridList>
				</div>
			);
	}

	render() {
		// console.log("RENDER IMAGE STATE",this.state.imagePreviewUrl)
		const props = this.props;
		let previewStyle = this.state.imagePreviewUrl?{backgroundImage:`url("${this.state.imagePreviewUrl}")`}:{}
		let iconPreviewStyle =this.state.imagePreviewUrl?{opacity:0.5}:{}
		return (
			<div className={props.classNameIS}>
				<Button
					variant="container"
					// labelPosition="before"
					// containerElement="label"
					style={{...props.styleButton, ...previewStyle}}
					disabled={
						this.props.disabledUploadPhoto
							? this.props.disabledUploadPhoto
							: false
					}
				>
					<FileUploadIcon color="primary" style={{fontSize:63, ...iconPreviewStyle}}/>
					{/*TODO Propagar el meta.field.error desde FileInput para informar las validaciones acá. */}
					<Field
						ref="field"
						name={props.fieldName}
						component={FileInput}
						validate={props.validate}
						style={styles.input}
						adaptEvent={this.adaptFileEventToValue}
						accept="image/x-png,image/jpeg"
						withRef
						disabled={
							this.props.disabledUploadPhoto
								? this.props.disabledUploadPhoto
								: false
						}
						validate={props.validate}
					/>
				</Button>
				{this.state.sizeErrorText ? (
					<div className="display-flex align-center">
						<InfoIcon color="#00529b" style={{ width: 16 }} />
						<p
							className="margin0 light"
							style={{ fontSize: 11, marginLeft: 5 }}
						>
							{this.state.sizeErrorText}
						</p>
					</div>
				) : null}
				{this.props.noPreview ? (
					<div className="display-flex align-center">
						<p
							className="margin0 light"
							style={{
								fontSize: 11,
								marginLeft: 5,
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis"
							}}
						>
							{this.state.fileName}
						</p>
						{this.props.showDelete&&this.state.imagePreviewUrl?
						<IconButton onClick={this.deleteFile}>
							<DeleteIcon color="primary" />
						</IconButton>
						:null}
					</div>
				) : (
						this.renderPreviews()
					)}
			</div>
		);
	}
}

export default ImageSelector;



// WEBPACK FOOTER //
// ./src/components/ImageSelector/ImageSelector.js